<div class="process-table-container">
  <p-table [value]="flatRows()" [tableStyle]="{ 'min-width': '60rem' }" [rowHover]="true" styleClass="cs-datatable-shadow cs-datatable-align-right-5-6">
    <ng-template pTemplate="header">
      <tr class="table-header cs-datatable-header-accent">
        <th>{{ 'Name' | translateWF: 'Name' }}</th>
        <th>{{ 'Type' | translateWF: 'Type' }}</th>
        <th>{{ 'Item_Code' | translateWF: 'Item Code' }}</th>
        <th>{{ 'Item_Description' | translateWF: 'Item Description' }}</th>
        <th>{{ 'UoM' | translateWF: 'UoM' }}</th>
        <th>{{ 'Qty' | translateWF: 'Qty' }}</th>
        @for (param of allParameterColumns(); track $index) {
          <th style="text-align: center">{{ param }}</th>
        }
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-row let-rowIndex="rowIndex">
      <tr [style.background-color]="row.backgroundColor || 'transparent'" [class]="'row-type-' + row.type">
        <!-- Name Column -->
        <td>
          @if (row.type === 'process' || row.type === 'step') {
            <strong>{{ row.name }}</strong>
          } @else {
            {{ row.name }}
          }
        </td>

        <!-- Type Column with Badge -->
        <td>
          @if (row.type === 'process') {
            <p-tag value="Process" severity="info" styleClass="cs-tag-solid" />
          } @else if (row.type === 'step') {
            <p-tag value="Step" severity="success" styleClass="cs-tag-solid" />
          } @else if (row.type === 'item-detail') {
            <span class="item-detail-label">Item Detail</span>
          }
        </td>

        <!-- Item Code -->
        <td>{{ row.itemCode || '' }}</td>

        <!-- Item Description -->
        <td>{{ row.itemDisplayName | localized }}</td>

        <!-- UoM -->
        <td>{{ row.uom || '' }}</td>

        <!-- Qty -->
        <td style="text-align: right">{{ row.qty || '' }}</td>

        <!-- Dynamic Parameter Columns -->
        @for (paramName of allParameterColumns(); track $index) {
          <td style="text-align: center">
            @if (getRowParameterValue(row, paramName); as paramData) {
              <p-tag [value]="getParameterValues(paramData.values)" [severity]="paramData.isRequired ? 'success' : 'warn'" styleClass="cs-tag-solid" />
            }
          </td>
        }
      </tr>
    </ng-template>

    <ng-template pTemplate="emptymessage">
      <tr>
        <td [attr.colspan]="7 + allParameterColumns().length" style="text-align: center">
          {{ 'No_Processes_Found' | translateWF: 'No processes found' }}
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>
